// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ReportDetailsWidget__Component[data-v-154cf05c] {\n  width: 100%;\n  border-radius: 3px;\n  padding: 10px;\n  border: 1px solid #e4eaf1;\n  position: relative;\n}\n.preview[data-v-154cf05c] {\n  position: absolute;\n  left: 10px;\n  top: 10px;\n  color: #57b7ca;\n  cursor: pointer;\n  font-weight: 500 !important;\n}\n.preview[data-v-154cf05c]:hover {\n    text-decoration: underline;\n}\n", ""]);
// Exports
module.exports = exports;
